import React from 'react';
import { useParams, Link } from 'react-router-dom';
import PageShell from './PageShell';
import { products } from '../mock';
import { ArrowLeft, Check } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import ProductGallery from '../components/ProductGallery';

const ProductDetailPage = () => {
  const { id } = useParams();
  const { t, lang } = useLang();
  const product = products.find((p) => p.id === id) || products[0];
  const c = product[lang] || product.en || product.it;
  const others = products.filter((p) => p.id !== product.id).slice(0, 3);
  const features = t('products.features');
  const gallery = product.gallery && product.gallery.length ? product.gallery : [product.image];

  return (
    <PageShell eyebrow={t('nav.prodotti')} title={c.title.toUpperCase()} image={product.image}>
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <Link to="/prodotti" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-semibold text-[#c53114] hover:text-[#0b2545]">
            <ArrowLeft size={16} /> {t('products.back')}
          </Link>

          <div className="mt-10 grid lg:grid-cols-2 gap-12 items-start">
            <ProductGallery images={gallery} alt={c.title} />
            <div>
              <p className="text-xs tracking-[0.3em] text-[#c53114] uppercase font-semibold">{c.subtitle}</p>
              <h2 className="mt-2 text-3xl md:text-4xl font-semibold text-[#0b2545]" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
                {c.title}
              </h2>
              <p className="mt-5 text-[#475569] leading-relaxed">{c.description}</p>

              <ul className="mt-8 space-y-3">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-[#0b2545]">
                    <span className="mt-1 w-5 h-5 rounded-full bg-[#fdece7] text-[#c53114] flex items-center justify-center flex-shrink-0">
                      <Check size={12} />
                    </span>
                    <span className="text-sm leading-relaxed">{f}</span>
                  </li>
                ))}
              </ul>

              <a href="#contatti" className="mt-10 inline-flex items-center gap-2 bg-[#0b2545] text-white px-7 py-3 tracking-[0.2em] text-sm uppercase font-semibold hover:bg-[#c53114] transition-colors">
                {t('products.request')}
              </a>
            </div>
          </div>

          <div className="mt-24">
            <h3 className="text-2xl font-semibold text-[#0b2545] mb-8" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
              {t('products.others')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {others.map((o) => {
                const oc = o[lang] || o.en || o.it;
                return (
                  <Link key={o.id} to={`/prodotti/${o.id}`} className="group block relative h-48 overflow-hidden">
                    <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{ backgroundImage: `url('${o.image}')` }} />
                    <div className="absolute inset-0 bg-[#0b2545]/60 group-hover:bg-[#0b2545]/40 transition-colors" />
                    <div className="relative h-full flex items-end p-5">
                      <h4 className="text-white text-xl font-semibold" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
                        {oc.title}
                      </h4>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default ProductDetailPage;
